import getConfig from 'next/config';
import { FaLine } from 'react-icons/fa';
import { RiTwitterLine, RiYoutubeLine } from 'react-icons/ri';
import {
  TiSocialFacebook
} from 'react-icons/ti';

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

export const APP_ENV = publicRuntimeConfig.NEXT_PUBLIC_APP_ENV || 'production';
export const API_URI = publicRuntimeConfig.NEXT_PUBLIC_API_URL || process.env.API_URL;
export const APP_URL = publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
export const APP_IMG = publicRuntimeConfig.NEXT_PUBLIC_IMG;
export const GTM_ID = publicRuntimeConfig.NEXT_PUBLIC_GTM_ID;

export const isProd = APP_ENV.toLowerCase() === 'production';
export const IS_NO_ROBOT_INDEX = !isProd;
/* ----------------------------- SERVER RUNTIME ----------------------------- */
export const SUPER_SECRET_KEY = serverRuntimeConfig.SUPER_SECRET_KEY;
export const RECAPTCHA_SECRET_KEY = serverRuntimeConfig.RECAPTCHA_SECRET_KEY;
export const REDIS_URL = serverRuntimeConfig.NEXT_PUBLIC_REDIS_URL;

/* ----------------------------- PUBLIC RUNTIME ----------------------------- */
export const SECRET_KEY_DATA = publicRuntimeConfig.SECRET_KEY_DATA;
export const IS_SHOW_AWARD =
  publicRuntimeConfig.IS_SHOW_AWARD || process.env.IS_SHOW_AWARD;
export const IS_SHOW_SCORE =
  publicRuntimeConfig.IS_SHOW_SCORE || process.env.IS_SHOW_SCORE;
export const IS_SHOW_NAME =
  publicRuntimeConfig.IS_SHOW_NAME || process.env.IS_SHOW_NAME;
export const IS_SHOW_SECTION =
  publicRuntimeConfig.IS_SHOW_SECTION || process.env.IS_SHOW_SECTION;
export const IS_SHOW_CODE =
  publicRuntimeConfig.IS_SHOW_CODE || process.env.IS_SHOW_CODE;
export const URL_MAIN = publicRuntimeConfig.URL_MAIN || process.env.URL_MAIN;
export const TRUEHITS_URL = publicRuntimeConfig.NEXT_PUBLIC_TRUEHITS_URL || process.env.NEXT_PUBLIC_TRUEHITS_URL;

export const CHECK_ADS = publicRuntimeConfig.CHECK_ADS;
export const SHOW_ADS = publicRuntimeConfig.SHOW_ADS;
export const SHOW_COMMEMORATE = publicRuntimeConfig.SHOW_COMMEMORATE || process.env.SHOW_COMMEMORATE;

/* ------------------------------- LOGO ------------------------------- */

export const LOGO_192 = 'Icon-192.png';
export const IMAGE_DEFAULT = `${APP_IMG}/awards/default.png`;

/* ----------------------------- WEB INFO ------------------------------ */

export const WEB_NAME = 'thansettakij';
export const WEB_NAME_EN = 'thansettakij';
export const WEB_TITLE = 'CEO Peoples Choice Awards 2025 | ฐานเศรษฐกิจ';
export const WEB_DESC = 'รางวัลยกย่องผู้นำระดับ CEO จาก 100 บริษัทชั้นนำใน SET 100 ผู้สร้างผลงานโดดเด่น สร้างแรงบันดาลใจ และพัฒนาธุรกิจอย่างยั่งยืน พร้อมสร้างคุณค่าให้สังคมไทย';
export const WEB_KEYWORD = 'รางวัลผู้บริหาร, CEO, ผู้นำธุรกิจ, ตลาดหุ้นไทย, SET 100, รางวัลแห่งปี';

export const TWITTER = {
  HANDLE: 'Thansettakij',
  CREATOR: '@thansettakij',
  SITE: '@thansettakij'
};

export const FACBOOK = {
  PAGE: '1023078414531349',
  APP_ID: '1023078414531349'
};

export const WEB_URL = {
  WEB: `${APP_URL}/`,
  FACEBOOK: 'https://www.facebook.com/thansettakij',
  X: 'https://x.com/thansettakij',
  LINE: 'https://page.line.me/thansettakij',
  YOUTUBE: 'https://www.youtube.com/channel/UCcTiVmhW5zC6mn71vYbDvpQ'
};

export const ADDRESS_ORG = {
  CONTENT: 'ชั้น 7 เลขที่ 1854 ถ.เทพรัตน แขวงบางนาใต้ เขตบางนา',
  PROVINCE: 'กรุงเทพฯ',
  REGION: 'TH',
  POSTCODE: '10260',
  COUNTRY: 'THAILAND'
};

/* ---------------------------------- THEME --------------------------------- */

export const THEME_WEB = '#256c59';
export const THEME_TITLE = '#FFFFFFFF';

export const SOCIAL_LIST = [
  { id: 1, icon: <TiSocialFacebook id='facebook'  />, link: WEB_URL.FACEBOOK, name: 'facebook', className: 'icon-facebook' },
  { id: 2, icon: <RiTwitterLine id='x' />, link: WEB_URL.X, name: 'x', className: 'icon-x' },
  { id: 3, icon: <FaLine id='line' />, link: WEB_URL.LINE, name: 'line', className: 'icon-line' },
  { id: 4, icon: <RiYoutubeLine id='youtube' />, link: WEB_URL.YOUTUBE, name: 'youtube', className: 'icon-youtube' }
];

// AUTH0
export const AUTH0_BASE_URL = serverRuntimeConfig.AUTH0_BASE_URL;
export const AUTH0_ISSUER_BASE_URL = serverRuntimeConfig.AUTH0_ISSUER_BASE_URL;
export const AUTH0_CLIENT_ID = serverRuntimeConfig.AUTH0_CLIENT_ID;
export const AUTH0_CLIENT_SECRET = serverRuntimeConfig.AUTH0_CLIENT_SECRET;
export const REDIS_HOST = serverRuntimeConfig.REDIS_HOST;
export const REDIS_PASSWORD = serverRuntimeConfig.REDIS_PASSWORD;
export const REDIS_TTL = serverRuntimeConfig.REDIS_TTL;

export const NEXT_PUBLIC_LOGIN_STATE_DATE = publicRuntimeConfig.NEXT_PUBLIC_LOGIN_STATE_DATE || 1;
export const NEXT_PUBLIC_LOGIN_COOKIE_DATE = publicRuntimeConfig.NEXT_PUBLIC_LOGIN_COOKIE_DATE || 1;

export const NEXT_PUBLIC_CF_SITE_KEY = publicRuntimeConfig.NEXT_PUBLIC_CF_SITE_KEY;
export const NEXT_SERVER_CF_SECRET_KEY = serverRuntimeConfig.NEXT_SERVER_CF_SECRET_KEY;
